import React from 'react';

const RadioGroupInput = ({ options, name, onChange, ...props }) => {
  const handleOptionChange = (value) => {
    if (onChange) {
      onChange({ target: { name, value } });
    }
  };

  return (
    <div className="radio-group-container">
      {options.map((option, index) => {
        return (
          <label
            key={name + '-' + index}
            className="radio-group w-full"
            onClick={() => handleOptionChange(option.value)}
          >
            <input
              type="radio"
              className="input"
              id={option.value.toLowerCase()}
              name={name}
              value={option.value}
              defaultChecked={props.value === option.value}
            />
            <span className="radio-mark"></span>
            <span className="w-[85%]">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioGroupInput;
